"use client";
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { useLanguage as N, Box as D, Paper as S, Overlay as j, Grid as s, Group as d, Paragraph as c, Heading as E, Divider as L, List as A, sharedHandler as V } from "@ingeniorforeningen/figurine-core";
import { forwardRef as k } from "react";
import { E as t, getItems as v } from "./EventDateAndVenue.helpers.js";
const m = k(
  ({
    active: i = !0,
    date: a,
    venueName: u,
    venueAddress: g,
    duration: y,
    deadline: f,
    inactiveDescription: p,
    variant: r = "primary",
    link: n,
    ...h
  }, x) => {
    const { language: l } = N();
    return /* @__PURE__ */ e(
      D,
      {
        component: i ? "a" : "div",
        href: n && n.href,
        target: n && n.target,
        className: t.linkWrapper,
        ...h,
        children: /* @__PURE__ */ o(
          S,
          {
            className: t.root,
            ref: x,
            variant: r,
            mod: { active: i },
            children: [
              r === "transparent" && /* @__PURE__ */ e(j, { color: "#ffffff", opacity: 0.1 }),
              i ? /* @__PURE__ */ o(s, { container: !0, columns: 21, className: t.content, children: [
                /* @__PURE__ */ e(s, { item: !0, span: 8, children: /* @__PURE__ */ o(d, { direction: "column", align: "center", justify: "center", spacing: 0, children: [
                  a && /* @__PURE__ */ e(
                    c,
                    {
                      text: `${a.toLocaleString(l, { year: "numeric" })}`,
                      transform: "uppercase",
                      strong: !0,
                      className: t.dateDisplaySecondary,
                      scale: 0.875,
                      variant: r === "primary" ? "dark" : "light",
                      mb: "xs"
                    }
                  ),
                  a && /* @__PURE__ */ e(
                    E,
                    {
                      text: `${a.toLocaleString(l, { day: "numeric" }).replace(".", "")}`,
                      type: "display",
                      className: t.dateDisplayPrimary,
                      scale: 0.8,
                      variant: r === "primary" ? "dark" : "light"
                    }
                  ),
                  a && /* @__PURE__ */ e(
                    c,
                    {
                      text: `${a.toLocaleString(l, { month: "long" })}`,
                      transform: "uppercase",
                      strong: !0,
                      className: t.dateDisplaySecondary,
                      variant: r === "primary" ? "dark" : "light",
                      mt: "xs",
                      scale: 0.875
                    }
                  )
                ] }) }),
                /* @__PURE__ */ e(s, { item: !0, span: 1, align: "center", justify: "center", children: /* @__PURE__ */ e(
                  L,
                  {
                    orientation: "vertical",
                    className: t.divider,
                    color: r === "primary" ? "dark" : "light"
                  }
                ) }),
                /* @__PURE__ */ e(s, { item: !0, span: 12, children: /* @__PURE__ */ e(d, { align: "center", justify: "left", children: /* @__PURE__ */ e(
                  A,
                  {
                    className: t.list,
                    lineHeight: "xs",
                    iconColor: "spot",
                    items: v({ venueName: u, venueAddress: g, duration: y, deadline: f, variant: r })
                  }
                ) }) })
              ] }) : p && /* @__PURE__ */ e(
                c,
                {
                  text: p,
                  align: "center",
                  variant: r === "primary" ? "dark" : "light"
                }
              )
            ]
          }
        )
      }
    );
  }
);
m.displayName = "EventDateAndVenue";
const H = V(
  m
);
H.displayName = m.displayName;
export {
  m as _EventDateAndVenue,
  H as default
};
